import api from '../api'

const baseUrl = '/BizSchool/api/PostComment'

const dadbananCommentsProvider = {
  getUserComment(payload) {
    return api.post(`${baseUrl}/GetById`, payload)
  },
  setStatus(payload) {
    return api.put(`${baseUrl}/Status`, payload)
  },
  replyToComment(payload) {
    return api.post(`${baseUrl}/AddReply`, payload)
  },
}

export default dadbananCommentsProvider
